module.exports = __webpack_public_path__ + "expand_less_white-v1-49c22dd5.svg";